const DetailItem = ({ title, children }) => (
  <div className="divgriselement">
    <h3 className="ptitulodetalle">{title}</h3>
    <p>{children}</p>
  </div>
);

export default DetailItem;
